module.exports = __webpack_public_path__ + "img/default-avatar.eab78723.png";